'use strict';

function ServiceManagementDataService(dataRetriever, dataTransformers) {
  function getData(selectedFlights, controlType) {
    return dataRetriever.getServiceManagementData(selectedFlights).then(function (data) {
      return dataTransformers.transform(data, controlType);
    });
  }
  return {
    getData: getData
  };
}
ServiceManagementDataService.$inject = ['FlightManagementDataRetrieverService', 'ServiceManagementDataTransformService'];
module.exports = ServiceManagementDataService;